export const pageSizeOptions = [10, 20, 50, 100];

export const defaultSearchParams: SearchParams = {
  pageNumber: 1,
  pageSize: pageSizeOptions[0],
  sortDirection: 'descending',
  sortField: 'created'
};
